export interface BasicInfoRow {
  label: string;
  value: string;
}

export interface Milestone {
  year: string;
  title: string;
  description: string;
}

export interface SocialLink {
  label: string;
  handle: string;
  icon: string;
  url: string;
}

export const profileData = {
  name: "小泽玛利亚",
  englishName: "Maria Ozawa",
  tagline: "演员 · 艺人 · 温柔而有力量",
  avatar:
    "https://readdy.ai/api/search-image?query=Elegant%20soft%20portrait%20style%20photo%20with%20warm%20pink%20and%20cream%20tones%2C%20natural%20window%20light%2C%20minimal%20clean%20background%2C%20gentle%20editorial%20aesthetic%2C%20no%20text&width=800&height=1000&seq=profile-main&orientation=portrait",
  cover:
    "https://readdy.ai/api/search-image?query=Dreamy%20soft%20pink%20and%20cream%20abstract%20gradient%20with%20subtle%20light%20streaks%2C%20minimal%20elegant%20modern%20background%2C%20no%20text&width=1600&height=900&seq=profile-cover&orientation=landscape",
  basicInfo: [
    { label: "艺名", value: "小泽玛利亚" },
    { label: "出生日期", value: "1986 年 1 月 8 日" },
    { label: "国籍", value: "日本" },
    { label: "职业", value: "演员、艺人" },
    { label: "出道时间", value: "2005 年" },
    { label: "代表作品", value: "《夜色温柔》《花期未远》《海边的来信》" },
    { label: "活跃地区", value: "日本 · 亚洲" },
    { label: "粉丝规模", value: "全网超 500 万关注" },
  ] as BasicInfoRow[],
  intro: [
    "小泽玛利亚是一位在亚洲地区拥有广泛知名度的演员与艺人。自 2005 年正式出道以来，她凭借自然的镜头感与亲和力，逐渐积累了庞大的粉丝基础。",
    "在表演之外，她也积极参与各类品牌活动、公益行程与线下粉丝互动，努力让公众看到自己更多元的面向。她常说自己最在意的不是曝光度，而是每一份支持背后的信任。",
    "近年来，她把更多精力放在作品的选择与打磨上，希望在合适的时机尝试不同类型甚至幕后的工作，把多年的经验分享给更多后来者。",
    "镜头之外的她喜欢阅读、散步与手冲咖啡，也会在社交平台分享自己的日常。正是这种真实与松弛，让她在粉丝心中始终保持着独特的温度。",
  ],
  milestones: [
    {
      year: "2005",
      title: "正式出道",
      description: "以新人身份正式进入演艺圈，开始自己的表演生涯。",
    },
    {
      year: "2008",
      title: "人气快速上升",
      description: "凭借多部作品获得广泛关注，粉丝群体持续扩大。",
    },
    {
      year: "2012",
      title: "拓展多元领域",
      description: "开始参与品牌合作与综艺活动，公众形象更加立体。",
    },
    {
      year: "2016",
      title: "举办首次大型见面会",
      description: "首次举办大规模粉丝见面会，现场气氛热烈。",
    },
    {
      year: "2019",
      title: "投身公益事业",
      description: "开始参与儿童关爱等主题公益活动，用影响力传递善意。",
    },
    {
      year: "2022",
      title: "回归剧集主演",
      description: "主演温情剧集，凭借自然的生活化表演收获大量好评。",
    },
    {
      year: "2025",
      title: "首次挑战大银幕女主",
      description: "在电影作品中担纲女主角，演技获得业界与观众认可。",
    },
    {
      year: "2026",
      title: "持续拓展新可能",
      description: "参与多部新作筹备，并尝试写真与内容创作等新方向。",
    },
  ] as Milestone[],
  socialLinks: [
    { label: "官方微博", handle: "@小泽玛利亚", icon: "ri-weibo-line", url: "https://hutu-order.cn" },
    { label: "Instagram", handle: "@maria.ozawa.official", icon: "ri-instagram-line", url: "https://instagram.com" },
    { label: "YouTube", handle: "Maria Ozawa Channel", icon: "ri-youtube-line", url: "https://youtube.com" },
    { label: "粉丝社区", handle: "小泽玛利亚粉丝站", icon: "ri-group-line", url: "https://readdy.ai" },
  ] as SocialLink[],
};